import i18n from '../lib/i18n'

// export const states = [
//   {
//     state: 'Baden-Württemberg',
//     code: 'BW',
//   },
//   {
//     state: 'Bayern',
//     code: 'BY',
//   },
//   {
//     state: 'Berlin',
//     code: 'BE',
//   },
//   {
//     state: 'Brandenburg',
//     code: 'BB',
//   },
//   {
//     state: 'Bremen',
//     code: 'HB',
//   },
//   {
//     state: 'Hamburg',
//     code: 'HH',
//   },
//   {
//     state: 'Hessen',
//     code: 'HE',
//   },
//   {
//     state: 'Mecklenburg-Vorpommern',
//     code: 'MV',
//   },
//   {
//     state: 'Niedersachsen',
//     code: 'NI',
//   },
//   {
//     state: 'Nordrhein-Westfalen',
//     code: 'NW',
//   },
//   {
//     state: 'Rheinland-Pfalz',
//     code: 'RP',
//   },
//   {
//     state: 'Saarland',
//     code: 'SL',
//   },
//   {
//     state: 'Sachsen',
//     code: 'SN',
//   },
//   {
//     state: 'Sachsen-Anhalt',
//     code: 'ST',
//   },
//   {
//     state: 'Schleswig-Holstein',
//     code: 'SH',
//   },
//   {
//     state: 'Thüringen',
//     code: 'TH',
//   },
// ]

export const countries = [
  {
    get country() {
      return i18n.t('frontend:country.AF.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AF.nationality')
    },
    requiresWorkPermit: true,
    code: 'AF',
    sasc: 423,
    ntkz: 'AFG',
    payments: [
      {
        overnightStayExpenses: 95,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 30,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.EG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.EG.nationality')
    },
    requiresWorkPermit: true,
    code: 'EG',
    sasc: 287,
    ntkz: 'ET',
    payments: [
      {
        overnightStayExpenses: 112,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AL.nationality')
    },
    requiresWorkPermit: true,
    code: 'AL',
    sasc: 121,
    ntkz: 'AL',
    payments: [
      {
        overnightStayExpenses: 112,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.DZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.DZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'DZ',
    sasc: 221,
    ntkz: 'DZ',
    payments: [
      {
        overnightStayExpenses: 120,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 47,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AD.nationality')
    },
    requiresWorkPermit: true,
    code: 'AD',
    sasc: 123,
    ntkz: 'AND',
    payments: [
      {
        overnightStayExpenses: 91,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AO.nationality')
    },
    requiresWorkPermit: true,
    code: 'AO',
    sasc: 223,
    ntkz: 'AGO',
    payments: [
      {
        overnightStayExpenses: 299,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AG.nationality')
    },
    requiresWorkPermit: true,
    code: 'AG',
    sasc: 320,
    ntkz: 'ATG',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GQ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GQ.nationality')
    },
    requiresWorkPermit: true,
    code: 'GQ',
    sasc: 274,
    ntkz: 'AQU',
    payments: [
      {
        overnightStayExpenses: 166,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AR.nationality')
    },
    requiresWorkPermit: true,
    code: 'AR',
    sasc: 323,
    ntkz: 'RA',
    payments: [
      {
        overnightStayExpenses: 113,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AM.nationality')
    },
    requiresWorkPermit: true,
    code: 'AM',
    sasc: 422,
    ntkz: 'ARM',
    payments: [
      {
        overnightStayExpenses: 59,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 24,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'AZ',
    sasc: 425,
    ntkz: 'ASE',
    payments: [
      {
        overnightStayExpenses: 88,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ET.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ET.nationality')
    },
    requiresWorkPermit: true,
    code: 'ET',
    sasc: 225,
    ntkz: 'ETH',
    payments: [
      {
        overnightStayExpenses: 130,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AU.nationality')
    },
    requiresWorkPermit: true,
    code: 'AU',
    sasc: 523,
    ntkz: 'AUS',
    payments: [
      {
        overnightStayExpenses: 173,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 186,
        additionalMealExpensesHalf: 49,
        additionalMealExpensesFull: 74,
        name: 'Canberra',
      },
      {
        overnightStayExpenses: 173,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Sydney',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BS.nationality')
    },
    requiresWorkPermit: true,
    code: 'BS',
    sasc: 324,
    ntkz: 'BS',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BH.nationality')
    },
    requiresWorkPermit: true,
    code: 'BH',
    sasc: 424,
    ntkz: 'BRN',
    payments: [
      {
        overnightStayExpenses: 153,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BD.nationality')
    },
    requiresWorkPermit: true,
    code: 'BD',
    sasc: 460,
    ntkz: 'BD',
    payments: [
      {
        overnightStayExpenses: 165,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BB.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BB.nationality')
    },
    requiresWorkPermit: true,
    code: 'BB',
    sasc: 322,
    ntkz: 'BDS',
    payments: [
      {
        overnightStayExpenses: 206,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 54,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BY.nationality')
    },
    requiresWorkPermit: true,
    code: 'BY',
    sasc: 169,
    ntkz: 'BY',
    payments: [
      {
        overnightStayExpenses: 98,
        additionalMealExpensesHalf: 13,
        additionalMealExpensesFull: 20,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BE.nationality')
    },
    requiresWorkPermit: false,
    code: 'BE',
    sasc: 124,
    ntkz: 'B',
    payments: [
      {
        overnightStayExpenses: 141,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'BZ',
    sasc: 330,
    ntkz: 'BH',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BJ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BJ.nationality')
    },
    requiresWorkPermit: true,
    code: 'BJ',
    sasc: 229,
    ntkz: 'DY',
    payments: [
      {
        overnightStayExpenses: 115,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BT.nationality')
    },
    requiresWorkPermit: true,
    code: 'BT',
    sasc: 426,
    ntkz: 'BHT',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BO.nationality')
    },
    requiresWorkPermit: true,
    code: 'BO',
    sasc: 326,
    ntkz: 'BOL',
    payments: [
      {
        overnightStayExpenses: 108,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BA.nationality')
    },
    requiresWorkPermit: true,
    code: 'BA',
    sasc: 122,
    ntkz: 'BIH',
    payments: [
      {
        overnightStayExpenses: 75,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BW.nationality')
    },
    requiresWorkPermit: true,
    code: 'BW',
    sasc: 227,
    ntkz: 'RB',
    payments: [
      {
        overnightStayExpenses: 176,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BR.nationality')
    },
    requiresWorkPermit: true,
    code: 'BR',
    sasc: 327,
    ntkz: 'BR',
    payments: [
      {
        overnightStayExpenses: 88,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 88,
        additionalMealExpensesHalf: 34,
        additionalMealExpensesFull: 51,
        name: 'Brasilia',
      },
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 46,
        additionalMealExpensesFull: 69,
        name: 'Rio de Janeiro',
      },
      {
        overnightStayExpenses: 151,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Sao Paulo',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BN.nationality')
    },
    requiresWorkPermit: true,
    code: 'BN',
    sasc: 429,
    ntkz: 'BRU',
    payments: [
      {
        overnightStayExpenses: 106,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BG.nationality')
    },
    requiresWorkPermit: false,
    code: 'BG',
    sasc: 125,
    ntkz: 'BG',
    payments: [
      {
        overnightStayExpenses: 115,
        additionalMealExpensesHalf: 15,
        additionalMealExpensesFull: 22,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BF.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BF.nationality')
    },
    requiresWorkPermit: true,
    code: 'BF',
    sasc: 258,
    ntkz: 'HV',
    payments: [
      {
        overnightStayExpenses: 174,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.BI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.BI.nationality')
    },
    requiresWorkPermit: true,
    code: 'BI',
    sasc: 291,
    ntkz: 'RU',
    payments: [
      {
        overnightStayExpenses: 138,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CL.nationality')
    },
    requiresWorkPermit: true,
    code: 'CL',
    sasc: 332,
    ntkz: 'RCH',
    payments: [
      {
        overnightStayExpenses: 154,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CN.nationality')
    },
    requiresWorkPermit: true,
    code: 'CN',
    sasc: 479,
    ntkz: 'TJ',
    payments: [
      {
        overnightStayExpenses: 112,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 131,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Chengdu',
      },
      {
        overnightStayExpenses: 150,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Kanton',
      },
      {
        overnightStayExpenses: 185,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 30,
        name: 'Peking',
      },
      {
        overnightStayExpenses: 217,
        additionalMealExpensesHalf: 39,
        additionalMealExpensesFull: 58,
        name: 'Shanghai',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CR.nationality')
    },
    requiresWorkPermit: true,
    code: 'CR',
    sasc: 334,
    ntkz: 'CR',
    payments: [
      {
        overnightStayExpenses: 93,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 47,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CI.nationality')
    },
    requiresWorkPermit: true,
    code: 'CI',
    sasc: 231,
    ntkz: 'CI',
    payments: [
      {
        overnightStayExpenses: 166,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.DK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.DK.nationality')
    },
    requiresWorkPermit: false,
    code: 'DK',
    sasc: 126,
    ntkz: 'DK',
    payments: [
      {
        overnightStayExpenses: 183,
        additionalMealExpensesHalf: 50,
        additionalMealExpensesFull: 75,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.DE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.DE.nationality')
    },
    requiresWorkPermit: false,
    code: 'DE',
    sasc: '000',
    ntkz: '0',
    payments: [
      {
        overnightStayExpenses: 20,
        additionalMealExpensesHalf: 14,
        additionalMealExpensesFull: 28,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.DO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.DO.nationality')
    },
    requiresWorkPermit: true,
    code: 'DO',
    sasc: 335,
    ntkz: 'DOM',
    payments: [
      {
        overnightStayExpenses: 167,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.DJ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.DJ.nationality')
    },
    requiresWorkPermit: true,
    code: 'DJ',
    sasc: 230,
    ntkz: 'DSC',
    payments: [
      {
        overnightStayExpenses: 255,
        additionalMealExpensesHalf: 52,
        additionalMealExpensesFull: 77,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.EC.name')
    },
    get nationality() {
      return i18n.t('frontend:country.EC.nationality')
    },
    requiresWorkPermit: true,
    code: 'EC',
    sasc: 336,
    ntkz: 'EC',
    payments: [
      {
        overnightStayExpenses: 103,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SV.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SV.nationality')
    },
    requiresWorkPermit: true,
    code: 'SV',
    sasc: 337,
    ntkz: 'ES',
    payments: [
      {
        overnightStayExpenses: 161,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ER.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ER.nationality')
    },
    requiresWorkPermit: true,
    code: 'ER',
    sasc: 224,
    ntkz: 'ERI',
    payments: [
      {
        overnightStayExpenses: 91,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.EE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.EE.nationality')
    },
    requiresWorkPermit: false,
    code: 'EE',
    sasc: 127,
    ntkz: 'EST',
    payments: [
      {
        overnightStayExpenses: 85,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.FJ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.FJ.nationality')
    },
    requiresWorkPermit: true,
    code: 'FJ',
    sasc: 526,
    ntkz: 'FJI',
    payments: [
      {
        overnightStayExpenses: 183,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.FI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.FI.nationality')
    },
    requiresWorkPermit: false,
    code: 'FI',
    sasc: 128,
    ntkz: 'FIN',
    payments: [
      {
        overnightStayExpenses: 171,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 54,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.FR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.FR.nationality')
    },
    requiresWorkPermit: false,
    code: 'FR',
    sasc: 129,
    ntkz: 'F',
    payments: [
      {
        overnightStayExpenses: 105,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 53,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 159,
        additionalMealExpensesHalf: 39,
        additionalMealExpensesFull: 58,
        name: 'Paris',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GA.nationality')
    },
    requiresWorkPermit: true,
    code: 'GA',
    sasc: 236,
    ntkz: 'GAB',
    payments: [
      {
        overnightStayExpenses: 183,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GM.nationality')
    },
    requiresWorkPermit: true,
    code: 'GM',
    sasc: 237,
    ntkz: 'WAG',
    payments: [
      {
        overnightStayExpenses: 161,
        additionalMealExpensesHalf: 27,
        additionalMealExpensesFull: 40,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GE.nationality')
    },
    requiresWorkPermit: true,
    code: 'GE',
    sasc: 430,
    ntkz: 'GEO',
    payments: [
      {
        overnightStayExpenses: 87,
        additionalMealExpensesHalf: 30,
        additionalMealExpensesFull: 45,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GH.nationality')
    },
    requiresWorkPermit: true,
    code: 'GH',
    sasc: 238,
    ntkz: 'GH',
    payments: [
      {
        overnightStayExpenses: 148,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GD.nationality')
    },
    requiresWorkPermit: true,
    code: 'GD',
    sasc: 340,
    ntkz: 'WG',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GR.nationality')
    },
    requiresWorkPermit: false,
    code: 'GR',
    sasc: 134,
    ntkz: 'GR',
    payments: [
      {
        overnightStayExpenses: 150,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 139,
        additionalMealExpensesHalf: 27,
        additionalMealExpensesFull: 40,
        name: 'Athen',
      },
    ],
  },
  //{ country: 'Grönland', nationality: 'grönländisch', code: 'GL' },
  {
    get country() {
      return i18n.t('frontend:country.GB.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GB.nationality')
    },
    requiresWorkPermit: true,
    code: 'GB',
    sasc: 168,
    ntkz: 'GB',
    payments: [
      {
        overnightStayExpenses: 99,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 163,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'London',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GT.nationality')
    },
    requiresWorkPermit: true,
    code: 'GT',
    sasc: 345,
    ntkz: 'GCA',
    payments: [
      {
        overnightStayExpenses: 90,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GN.nationality')
    },
    requiresWorkPermit: true,
    code: 'GN',
    sasc: 261,
    ntkz: 'RG',
    payments: [
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GW.nationality')
    },
    requiresWorkPermit: true,
    code: 'GW',
    sasc: 259,
    ntkz: 'GUB',
    payments: [
      {
        overnightStayExpenses: 113,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.GY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.GY.nationality')
    },
    requiresWorkPermit: true,
    code: 'GY',
    sasc: 328,
    ntkz: 'GUY',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.HT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.HT.nationality')
    },
    requiresWorkPermit: true,
    code: 'HT',
    sasc: 346,
    ntkz: 'RH',
    payments: [
      {
        overnightStayExpenses: 130,
        additionalMealExpensesHalf: 39,
        additionalMealExpensesFull: 58,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.HN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.HN.nationality')
    },
    requiresWorkPermit: true,
    code: 'HN',
    sasc: 347,
    ntkz: 'HCA',
    payments: [
      {
        overnightStayExpenses: 198,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.HK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.HK.nationality')
    },
    requiresWorkPermit: true,
    code: 'HK',
    sasc: 411,
    ntkz: 'HKG',
    payments: [
      {
        overnightStayExpenses: 169,
        additionalMealExpensesHalf: 48,
        additionalMealExpensesFull: 71,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IN.nationality')
    },
    requiresWorkPermit: true,
    code: 'IN',
    sasc: 436,
    ntkz: 'IND',
    payments: [
      {
        overnightStayExpenses: 85,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 85,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Chennai',
      },
      {
        overnightStayExpenses: 145,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Kalkutta',
      },
      {
        overnightStayExpenses: 146,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Mumbai',
      },
      {
        overnightStayExpenses: 185,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Neu Delhi',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ID.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ID.nationality')
    },
    requiresWorkPermit: true,
    code: 'ID',
    sasc: 437,
    ntkz: 'RI',
    payments: [
      {
        overnightStayExpenses: 134,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IQ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IQ.nationality')
    },
    requiresWorkPermit: true,
    code: 'IQ',
    sasc: 438,
    ntkz: 'IRQ',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IR.nationality')
    },
    requiresWorkPermit: true,
    code: 'IR',
    sasc: 439,
    ntkz: 'IR',
    payments: [
      {
        overnightStayExpenses: 196,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IE.nationality')
    },
    requiresWorkPermit: false,
    code: 'IE',
    sasc: 135,
    ntkz: 'IRL',
    payments: [
      {
        overnightStayExpenses: 129,
        additionalMealExpensesHalf: 39,
        additionalMealExpensesFull: 58,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IS.nationality')
    },
    requiresWorkPermit: false,
    code: 'IS',
    sasc: 136,
    ntkz: 'IS',
    payments: [
      {
        overnightStayExpenses: 187,
        additionalMealExpensesHalf: 41,
        additionalMealExpensesFull: 62,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IL.nationality')
    },
    requiresWorkPermit: true,
    code: 'IL',
    sasc: 441,
    ntkz: 'IL',
    payments: [
      {
        overnightStayExpenses: 190,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.IT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.IT.nationality')
    },
    requiresWorkPermit: false,
    code: 'IT',
    sasc: 137,
    ntkz: 'I',
    payments: [
      {
        overnightStayExpenses: 150,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 191,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Mailand',
      },
      {
        overnightStayExpenses: 150,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rom',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.JM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.JM.nationality')
    },
    requiresWorkPermit: true,
    code: 'JM',
    sasc: 355,
    ntkz: 'JA',
    payments: [
      {
        overnightStayExpenses: 171,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.JP.name')
    },
    get nationality() {
      return i18n.t('frontend:country.JP.nationality')
    },
    requiresWorkPermit: true,
    code: 'JP',
    sasc: 442,
    ntkz: 'J',
    payments: [
      {
        overnightStayExpenses: 190,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 285,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Tokio',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.YE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.YE.nationality')
    },
    requiresWorkPermit: true,
    code: 'YE',
    sasc: 421,
    ntkz: 'YEM',
    payments: [
      {
        overnightStayExpenses: 95,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 24,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.JO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.JO.nationality')
    },
    requiresWorkPermit: true,
    code: 'JO',
    sasc: 445,
    ntkz: 'JOR',
    payments: [
      {
        overnightStayExpenses: 134,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KH.nationality')
    },
    requiresWorkPermit: true,
    code: 'KH',
    sasc: 446,
    ntkz: 'K',
    payments: [
      {
        overnightStayExpenses: 94,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CM.nationality')
    },
    requiresWorkPermit: true,
    code: 'CM',
    sasc: 262,
    ntkz: 'CAM',
    payments: [
      {
        overnightStayExpenses: 275,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CA.nationality')
    },
    requiresWorkPermit: true,
    code: 'CA',
    sasc: 348,
    ntkz: 'CDN',
    payments: [
      {
        overnightStayExpenses: 214,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 54,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 214,
        additionalMealExpensesHalf: 41,
        additionalMealExpensesFull: 62,
        name: 'Ottawa',
      },
      {
        overnightStayExpenses: 392,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 54,
        name: 'Toronto',
      },
      {
        overnightStayExpenses: 304,
        additionalMealExpensesHalf: 42,
        additionalMealExpensesFull: 63,
        name: 'Vancouver',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'KZ',
    sasc: 444,
    ntkz: 'KAS',
    payments: [
      {
        overnightStayExpenses: 111,
        additionalMealExpensesHalf: 30,
        additionalMealExpensesFull: 45,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.QA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.QA.nationality')
    },
    requiresWorkPermit: true,
    code: 'QA',
    sasc: 447,
    ntkz: 'QAT',
    payments: [
      {
        overnightStayExpenses: 149,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KE.nationality')
    },
    requiresWorkPermit: true,
    code: 'KE',
    sasc: 243,
    ntkz: 'EAK',
    payments: [
      {
        overnightStayExpenses: 219,
        additionalMealExpensesHalf: 34,
        additionalMealExpensesFull: 51,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KG.nationality')
    },
    requiresWorkPermit: true,
    code: 'KG',
    sasc: 450,
    ntkz: 'KIS',
    payments: [
      {
        overnightStayExpenses: 74,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KI.nationality')
    },
    requiresWorkPermit: true,
    code: 'KI',
    sasc: 530,
    ntkz: 'KIB',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CO.nationality')
    },
    requiresWorkPermit: true,
    code: 'CO',
    sasc: 349,
    ntkz: 'CO',
    payments: [
      {
        overnightStayExpenses: 115,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KM.nationality')
    },
    requiresWorkPermit: true,
    code: 'KM',
    sasc: 244,
    ntkz: 'KOM',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CD.nationality')
    },
    requiresWorkPermit: true,
    code: 'CD',
    sasc: 245,
    ntkz: 'ZRE',
    payments: [
      {
        overnightStayExpenses: 190,
        additionalMealExpensesHalf: 47,
        additionalMealExpensesFull: 70,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.XK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.XK.nationality')
    },
    requiresWorkPermit: true,
    code: 'XK',
    sasc: 150,
    ntkz: 'KOS',
    payments: [
      {
        overnightStayExpenses: 71,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 24,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KR.nationality')
    },
    requiresWorkPermit: true,
    code: 'KR',
    sasc: 467,
    ntkz: 'ROK',
    payments: [
      {
        overnightStayExpenses: 92,
        additionalMealExpensesHalf: 19,
        additionalMealExpensesFull: 28,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.HR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.HR.nationality')
    },
    requiresWorkPermit: false,
    code: 'HR',
    sasc: 130,
    ntkz: 'HR',
    payments: [
      {
        overnightStayExpenses: 107,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CU.nationality')
    },
    requiresWorkPermit: true,
    code: 'CU',
    sasc: 351,
    ntkz: 'C',
    payments: [
      {
        overnightStayExpenses: 170,
        additionalMealExpensesHalf: 34,
        additionalMealExpensesFull: 51,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.KW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.KW.nationality')
    },
    requiresWorkPermit: true,
    code: 'KW',
    sasc: 448,
    ntkz: 'KWT',
    payments: [
      {
        overnightStayExpenses: 241,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LA.nationality')
    },
    requiresWorkPermit: true,
    code: 'LA',
    sasc: 449,
    ntkz: 'LAO',
    payments: [
      {
        overnightStayExpenses: 71,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LS.nationality')
    },
    requiresWorkPermit: true,
    code: 'LS',
    sasc: 226,
    ntkz: 'LS',
    payments: [
      {
        overnightStayExpenses: 104,
        additionalMealExpensesHalf: 19,
        additionalMealExpensesFull: 28,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LV.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LV.nationality')
    },
    requiresWorkPermit: false,
    code: 'LV',
    sasc: 139,
    ntkz: 'LV',
    payments: [
      {
        overnightStayExpenses: 76,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LB.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LB.nationality')
    },
    requiresWorkPermit: true,
    code: 'LB',
    sasc: 451,
    ntkz: 'RL',
    payments: [
      {
        overnightStayExpenses: 146,
        additionalMealExpensesHalf: 46,
        additionalMealExpensesFull: 69,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LR.nationality')
    },
    requiresWorkPermit: true,
    code: 'LR',
    sasc: 247,
    ntkz: 'LB',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LY.nationality')
    },
    requiresWorkPermit: true,
    code: 'LY',
    sasc: 248,
    ntkz: 'LAR',
    payments: [
      {
        overnightStayExpenses: 135,
        additionalMealExpensesHalf: 42,
        additionalMealExpensesFull: 63,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LI.nationality')
    },
    requiresWorkPermit: false,
    code: 'LI',
    sasc: 141,
    ntkz: 'FL',
    payments: [
      {
        overnightStayExpenses: 190,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LT.nationality')
    },
    requiresWorkPermit: false,
    code: 'LT',
    sasc: 142,
    ntkz: 'LT',
    payments: [
      {
        overnightStayExpenses: 109,
        additionalMealExpensesHalf: 17,
        additionalMealExpensesFull: 26,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LU.nationality')
    },
    requiresWorkPermit: false,
    code: 'LU',
    sasc: 143,
    ntkz: 'L',
    payments: [
      {
        overnightStayExpenses: 139,
        additionalMealExpensesHalf: 42,
        additionalMealExpensesFull: 63,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MG.nationality')
    },
    requiresWorkPermit: true,
    code: 'MG',
    sasc: 249,
    ntkz: 'RM',
    payments: [
      {
        overnightStayExpenses: 116,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MW.nationality')
    },
    requiresWorkPermit: true,
    code: 'MW',
    sasc: 256,
    ntkz: 'MW',
    payments: [
      {
        overnightStayExpenses: 109,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MY.nationality')
    },
    requiresWorkPermit: true,
    code: 'MY',
    sasc: 482,
    ntkz: 'MAL',
    payments: [
      {
        overnightStayExpenses: 86,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MV.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MV.nationality')
    },
    requiresWorkPermit: true,
    code: 'MV',
    sasc: 454,
    ntkz: 'BIO',
    payments: [
      {
        overnightStayExpenses: 170,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ML.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ML.nationality')
    },
    requiresWorkPermit: true,
    code: 'ML',
    sasc: 251,
    ntkz: 'RMM',
    payments: [
      {
        overnightStayExpenses: 120,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MT.nationality')
    },
    requiresWorkPermit: false,
    code: 'MT',
    sasc: 145,
    ntkz: 'M',
    payments: [
      {
        overnightStayExpenses: 114,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MA.nationality')
    },
    requiresWorkPermit: true,
    code: 'MA',
    sasc: 252,
    ntkz: 'MA',
    payments: [
      {
        overnightStayExpenses: 87,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MH.nationality')
    },
    requiresWorkPermit: true,
    code: 'MH',
    sasc: 544,
    ntkz: null,
    payments: [
      {
        overnightStayExpenses: 102,
        additionalMealExpensesHalf: 42,
        additionalMealExpensesFull: 63,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MR.nationality')
    },
    requiresWorkPermit: true,
    code: 'MR',
    sasc: 239,
    ntkz: 'RIM',
    payments: [
      {
        overnightStayExpenses: 86,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MU.nationality')
    },
    requiresWorkPermit: true,
    code: 'MU',
    sasc: 253,
    ntkz: 'MS',
    payments: [
      {
        overnightStayExpenses: 172,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MX.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MX.nationality')
    },
    requiresWorkPermit: true,
    code: 'MX',
    sasc: 353,
    ntkz: 'MEX',
    payments: [
      {
        overnightStayExpenses: 177,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.FM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.FM.nationality')
    },
    requiresWorkPermit: true,
    code: 'FM',
    sasc: 545,
    ntkz: 'MIK',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MD.nationality')
    },
    requiresWorkPermit: true,
    code: 'MD',
    sasc: 146,
    ntkz: 'MD',
    payments: [
      {
        overnightStayExpenses: 73,
        additionalMealExpensesHalf: 17,
        additionalMealExpensesFull: 26,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MC.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MC.nationality')
    },
    requiresWorkPermit: true,
    code: 'MC',
    sasc: 147,
    ntkz: 'MC',
    payments: [
      {
        overnightStayExpenses: 187,
        additionalMealExpensesHalf: 35,
        additionalMealExpensesFull: 52,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MN.nationality')
    },
    requiresWorkPermit: true,
    code: 'MN',
    sasc: 457,
    ntkz: 'MON',
    payments: [
      {
        overnightStayExpenses: 92,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 23,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ME.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ME.nationality')
    },
    requiresWorkPermit: true,
    code: 'ME',
    sasc: 140,
    ntkz: 'MNE',
    payments: [
      {
        overnightStayExpenses: 85,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'MZ',
    sasc: 254,
    ntkz: 'MOZ',
    payments: [
      {
        overnightStayExpenses: 208,
        additionalMealExpensesHalf: 34,
        additionalMealExpensesFull: 51,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MM.nationality')
    },
    requiresWorkPermit: true,
    code: 'MM',
    sasc: 427,
    ntkz: 'MYA',
    payments: [
      {
        overnightStayExpenses: 155,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 35,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NA.nationality')
    },
    requiresWorkPermit: true,
    code: 'NA',
    sasc: 267,
    ntkz: 'SWA',
    payments: [
      {
        overnightStayExpenses: 112,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 30,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NR.nationality')
    },
    requiresWorkPermit: true,
    code: 'NR',
    sasc: 531,
    ntkz: 'NAU',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NP.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NP.nationality')
    },
    requiresWorkPermit: true,
    code: 'NP',
    sasc: 458,
    ntkz: 'NEP',
    payments: [
      {
        overnightStayExpenses: 126,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'NZ',
    sasc: 536,
    ntkz: 'NZ',
    payments: [
      {
        overnightStayExpenses: 148,
        additionalMealExpensesHalf: 39,
        additionalMealExpensesFull: 58,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NI.nationality')
    },
    requiresWorkPermit: true,
    code: 'NI',
    sasc: 354,
    ntkz: 'NIC',
    payments: [
      {
        overnightStayExpenses: 105,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NL.nationality')
    },
    requiresWorkPermit: false,
    code: 'NL',
    sasc: 148,
    ntkz: 'NL',
    payments: [
      {
        overnightStayExpenses: 122,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 47,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NE.nationality')
    },
    requiresWorkPermit: true,
    code: 'NE',
    sasc: 255,
    ntkz: 'RN',
    payments: [
      {
        overnightStayExpenses: 131,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NG.nationality')
    },
    requiresWorkPermit: true,
    code: 'NG',
    sasc: 232,
    ntkz: 'WAN',
    payments: [
      {
        overnightStayExpenses: 182,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.NO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.NO.nationality')
    },
    requiresWorkPermit: false,
    code: 'NO',
    sasc: 149,
    ntkz: 'N',
    payments: [
      {
        overnightStayExpenses: 139,
        additionalMealExpensesHalf: 50,
        additionalMealExpensesFull: 75,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.MK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.MK.nationality')
    },
    code: 'MK',
    sasc: 144,
    ntkz: 'NMK',
    payments: [
      {
        overnightStayExpenses: 89,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.OM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.OM.nationality')
    },
    requiresWorkPermit: true,
    code: 'OM',
    sasc: 456,
    ntkz: 'MAO',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AT.nationality')
    },
    requiresWorkPermit: false,
    code: 'AT',
    sasc: 151,
    ntkz: 'A',
    payments: [
      {
        overnightStayExpenses: 117,
        additionalMealExpensesHalf: 33,
        additionalMealExpensesFull: 50,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PK.nationality')
    },
    requiresWorkPermit: true,
    code: 'PK',
    sasc: 461,
    ntkz: 'PK',
    payments: [
      {
        overnightStayExpenses: 122,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 238,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 23,
        name: 'Islamabad',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PW.nationality')
    },
    requiresWorkPermit: true,
    code: 'PW',
    sasc: 537,
    ntkz: 'PAL',
    payments: [
      {
        overnightStayExpenses: 179,
        additionalMealExpensesHalf: 34,
        additionalMealExpensesFull: 51,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PA.nationality')
    },
    requiresWorkPermit: true,
    code: 'PA',
    sasc: 357,
    ntkz: 'PA',
    payments: [
      {
        overnightStayExpenses: 82,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PG.nationality')
    },
    requiresWorkPermit: true,
    code: 'PG',
    sasc: 538,
    ntkz: 'PNG',
    payments: [
      {
        overnightStayExpenses: 159,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PY.nationality')
    },
    requiresWorkPermit: true,
    code: 'PY',
    sasc: 359,
    ntkz: 'PY',
    payments: [
      {
        overnightStayExpenses: 124,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PE.nationality')
    },
    requiresWorkPermit: true,
    code: 'PE',
    sasc: 361,
    ntkz: 'PE',
    payments: [
      {
        overnightStayExpenses: 143,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PH.nationality')
    },
    requiresWorkPermit: true,
    code: 'PH',
    sasc: 462,
    ntkz: 'RP',
    payments: [
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PL.nationality')
    },
    requiresWorkPermit: false,
    code: 'PL',
    sasc: 152,
    ntkz: 'PL',
    payments: [
      {
        overnightStayExpenses: 60,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 29,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 117,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Breslau',
      },
      {
        overnightStayExpenses: 84,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 30,
        name: 'Danzig',
      },
      {
        overnightStayExpenses: 86,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Krakau',
      },
      {
        overnightStayExpenses: 109,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 29,
        name: 'Warschau',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PT.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PT.nationality')
    },
    requiresWorkPermit: false,
    code: 'PT',
    sasc: 153,
    ntkz: 'P',
    payments: [
      {
        overnightStayExpenses: 111,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.PR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.PR.nationality')
    },
    requiresWorkPermit: true,
    code: 'PR',
    sasc: -1,
    ntkz: 'PRI',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.RW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.RW.nationality')
    },
    requiresWorkPermit: true,
    code: 'RW',
    sasc: 265,
    ntkz: 'RWA',
    payments: [
      {
        overnightStayExpenses: 117,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.RO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.RO.nationality')
    },
    requiresWorkPermit: false,
    code: 'RO',
    sasc: 154,
    ntkz: 'RO',
    payments: [
      {
        overnightStayExpenses: 89,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 92,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Bukarest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.RU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.RU.nationality')
    },
    requiresWorkPermit: true,
    code: 'RU',
    sasc: 160,
    ntkz: 'RUS',
    payments: [
      {
        overnightStayExpenses: 58,
        additionalMealExpensesHalf: 16,
        additionalMealExpensesFull: 24,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 84,
        additionalMealExpensesHalf: 19,
        additionalMealExpensesFull: 28,
        name: 'Jekaterinburg',
      },
      {
        overnightStayExpenses: 110,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 30,
        name: 'Moskau',
      },
      {
        overnightStayExpenses: 114,
        additionalMealExpensesHalf: 17,
        additionalMealExpensesFull: 26,
        name: 'St. Petersburg',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SB.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SB.nationality')
    },
    requiresWorkPermit: true,
    code: 'SB',
    sasc: 524,
    ntkz: 'SOL',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ZM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ZM.nationality')
    },
    requiresWorkPermit: true,
    code: 'ZM',
    sasc: 257,
    ntkz: 'Z',
    payments: [
      {
        overnightStayExpenses: 105,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.WS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.WS.nationality')
    },
    requiresWorkPermit: true,
    code: 'WS',
    sasc: 543,
    ntkz: 'WS',
    payments: [
      {
        overnightStayExpenses: 105,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SM.nationality')
    },
    requiresWorkPermit: true,
    code: 'SM',
    sasc: 156,
    ntkz: 'RSM',
    payments: [
      {
        overnightStayExpenses: 79,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SA.nationality')
    },
    requiresWorkPermit: true,
    code: 'SA',
    sasc: 472,
    ntkz: 'SAU',
    payments: [
      {
        overnightStayExpenses: 181,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 181,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Djidda',
      },
      {
        overnightStayExpenses: 186,
        additionalMealExpensesHalf: 37,
        additionalMealExpensesFull: 56,
        name: 'Riad',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SE.nationality')
    },
    requiresWorkPermit: false,
    code: 'SE',
    sasc: 157,
    ntkz: 'S',
    payments: [
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CH.nationality')
    },
    requiresWorkPermit: false,
    code: 'CH',
    sasc: 158,
    ntkz: 'CH',
    payments: [
      {
        overnightStayExpenses: 180,
        additionalMealExpensesHalf: 43,
        additionalMealExpensesFull: 64,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 186,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'Genf',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SN.nationality')
    },
    requiresWorkPermit: true,
    code: 'SN',
    sasc: 269,
    ntkz: 'SN',
    payments: [
      {
        overnightStayExpenses: 190,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.RS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.RS.nationality')
    },
    requiresWorkPermit: true,
    code: 'RS',
    sasc: 170,
    ntkz: 'SRB',
    payments: [
      {
        overnightStayExpenses: 97,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SC.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SC.nationality')
    },
    requiresWorkPermit: true,
    code: 'SC',
    sasc: 271,
    ntkz: 'SY',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SL.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SL.nationality')
    },
    requiresWorkPermit: true,
    code: 'SL',
    sasc: 272,
    ntkz: 'WAL',
    payments: [
      {
        overnightStayExpenses: 145,
        additionalMealExpensesHalf: 38,
        additionalMealExpensesFull: 57,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ZW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ZW.nationality')
    },
    requiresWorkPermit: true,
    code: 'ZW',
    sasc: 233,
    ntkz: 'ZW',
    payments: [
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 30,
        additionalMealExpensesFull: 45,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SG.nationality')
    },
    requiresWorkPermit: true,
    code: 'SG',
    sasc: 474,
    ntkz: 'SGP',
    payments: [
      {
        overnightStayExpenses: 197,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 54,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SK.nationality')
    },
    requiresWorkPermit: false,
    code: 'SK',
    sasc: 155,
    ntkz: 'SK',
    payments: [
      {
        overnightStayExpenses: 121,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SI.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SI.nationality')
    },
    requiresWorkPermit: false,
    code: 'SI',
    sasc: 131,
    ntkz: 'SLO',
    payments: [
      {
        overnightStayExpenses: 126,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SO.nationality')
    },
    requiresWorkPermit: true,
    code: 'SO',
    sasc: 273,
    ntkz: 'SP',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ES.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ES.nationality')
    },
    requiresWorkPermit: false,
    code: 'ES',
    sasc: 161,
    ntkz: 'E',
    payments: [
      {
        overnightStayExpenses: 103,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 144,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Barcelona',
      },
      {
        overnightStayExpenses: 103,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Kanarische Inseln',
      },
      {
        overnightStayExpenses: 131,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Madrid',
      },
      {
        overnightStayExpenses: 142,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Palma de Mallorca',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.LK.name')
    },
    get nationality() {
      return i18n.t('frontend:country.LK.nationality')
    },
    requiresWorkPermit: true,
    code: 'LK',
    sasc: 431,
    ntkz: 'CL',
    payments: [
      {
        overnightStayExpenses: 112,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.ZA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.ZA.nationality')
    },
    requiresWorkPermit: true,
    code: 'ZA',
    sasc: 263,
    ntkz: 'ZA',
    payments: [
      {
        overnightStayExpenses: 109,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 29,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 130,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Kapstadt',
      },
      {
        overnightStayExpenses: 129,
        additionalMealExpensesHalf: 24,
        additionalMealExpensesFull: 36,
        name: 'Johannesburg',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SD.nationality')
    },
    requiresWorkPermit: true,
    code: 'SD',
    sasc: 277,
    ntkz: 'SDN',
    payments: [
      {
        overnightStayExpenses: 195,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SR.nationality')
    },
    requiresWorkPermit: true,
    code: 'SR',
    sasc: 364,
    ntkz: 'SME',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.SY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.SY.nationality')
    },
    requiresWorkPermit: true,
    code: 'SY',
    sasc: 275,
    ntkz: 'SYR',
    payments: [
      {
        overnightStayExpenses: 140,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  // { country: 'Syrien, Arabische Republik', nationality: 'syrisch', code: 'SY' },
  {
    get country() {
      return i18n.t('frontend:country.TJ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TJ.nationality')
    },
    requiresWorkPermit: true,
    code: 'TJ',
    sasc: 470,
    ntkz: 'TAD',
    payments: [
      {
        overnightStayExpenses: 118,
        additionalMealExpensesHalf: 18,
        additionalMealExpensesFull: 27,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TW.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TW.nationality')
    },
    requiresWorkPermit: true,
    code: 'TW',
    sasc: 465,
    ntkz: 'TWN',
    payments: [
      {
        overnightStayExpenses: 143,
        additionalMealExpensesHalf: 31,
        additionalMealExpensesFull: 46,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'TZ',
    sasc: 282,
    ntkz: 'EAT',
    payments: [
      {
        overnightStayExpenses: 97,
        additionalMealExpensesHalf: 29,
        additionalMealExpensesFull: 44,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TH.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TH.nationality')
    },
    requiresWorkPermit: true,
    code: 'TH',
    sasc: 476,
    ntkz: 'T',
    payments: [
      {
        overnightStayExpenses: 110,
        additionalMealExpensesHalf: 25,
        additionalMealExpensesFull: 38,
        name: 'Rest',
      },
    ],
  },
  // { country: 'Timor-Leste', nationality: 'timoresisch', code: 'TL' },
  {
    get country() {
      return i18n.t('frontend:country.TG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TG.nationality')
    },
    requiresWorkPermit: true,
    code: 'TG',
    sasc: 283,
    ntkz: 'TG',
    payments: [
      {
        overnightStayExpenses: 118,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TO.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TO.nationality')
    },
    requiresWorkPermit: true,
    code: 'TO',
    sasc: 541,
    ntkz: 'TON',
    payments: [
      {
        overnightStayExpenses: 94,
        additionalMealExpensesHalf: 26,
        additionalMealExpensesFull: 39,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TD.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TD.nationality')
    },
    requiresWorkPermit: true,
    code: 'TD',
    sasc: 284,
    ntkz: 'CHD',
    payments: [
      {
        overnightStayExpenses: 155,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CZ.nationality')
    },
    requiresWorkPermit: false,
    code: 'CZ',
    sasc: 164,
    ntkz: 'CZ',
    payments: [
      {
        overnightStayExpenses: 77,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TN.nationality')
    },
    requiresWorkPermit: true,
    code: 'TN',
    sasc: 285,
    ntkz: 'TN',
    payments: [
      {
        overnightStayExpenses: 144,
        additionalMealExpensesHalf: 27,
        additionalMealExpensesFull: 40,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TR.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TR.nationality')
    },
    requiresWorkPermit: true,
    code: 'TR',
    sasc: 163,
    ntkz: 'TR',
    payments: [
      {
        overnightStayExpenses: 95,
        additionalMealExpensesHalf: 12,
        additionalMealExpensesFull: 17,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 120,
        additionalMealExpensesHalf: 17,
        additionalMealExpensesFull: 26,
        name: 'Istanbul',
      },
      {
        overnightStayExpenses: 55,
        additionalMealExpensesHalf: 20,
        additionalMealExpensesFull: 29,
        name: 'Izmir',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TM.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TM.nationality')
    },
    requiresWorkPermit: true,
    code: 'TM',
    sasc: 471,
    ntkz: 'TUR',
    payments: [
      {
        overnightStayExpenses: 108,
        additionalMealExpensesHalf: 22,
        additionalMealExpensesFull: 33,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.TV.name')
    },
    get nationality() {
      return i18n.t('frontend:country.TV.nationality')
    },
    requiresWorkPermit: true,
    code: 'TV',
    sasc: 540,
    ntkz: 'TUV',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.UG.name')
    },
    get nationality() {
      return i18n.t('frontend:country.UG.nationality')
    },
    requiresWorkPermit: true,
    code: 'UG',
    sasc: 286,
    ntkz: 'EAU',
    payments: [
      {
        overnightStayExpenses: 143,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.UA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.UA.nationality')
    },
    requiresWorkPermit: true,
    code: 'UA',
    sasc: 166,
    ntkz: 'UA',
    payments: [
      {
        overnightStayExpenses: 98,
        additionalMealExpensesHalf: 17,
        additionalMealExpensesFull: 26,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.HU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.HU.nationality')
    },
    requiresWorkPermit: false,
    code: 'HU',
    sasc: 165,
    ntkz: 'H',
    payments: [
      {
        overnightStayExpenses: 85,
        additionalMealExpensesHalf: 21,
        additionalMealExpensesFull: 32,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.UY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.UY.nationality')
    },
    requiresWorkPermit: true,
    code: 'UY',
    sasc: 365,
    ntkz: 'ROU',
    payments: [
      {
        overnightStayExpenses: 90,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.UZ.name')
    },
    get nationality() {
      return i18n.t('frontend:country.UZ.nationality')
    },
    requiresWorkPermit: true,
    code: 'UZ',
    sasc: 477,
    ntkz: 'USB',
    payments: [
      {
        overnightStayExpenses: 104,
        additionalMealExpensesHalf: 23,
        additionalMealExpensesFull: 34,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.VU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.VU.nationality')
    },
    requiresWorkPermit: true,
    code: 'VU',
    sasc: 532,
    ntkz: 'VAN',
    payments: [
      {
        overnightStayExpenses: 0,
        additionalMealExpensesHalf: 0,
        additionalMealExpensesFull: 0,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.VA.name')
    },
    get nationality() {
      return i18n.t('frontend:country.VA.nationality')
    },
    requiresWorkPermit: true,
    code: 'VA',
    sasc: 167,
    ntkz: 'V',
    payments: [
      {
        overnightStayExpenses: 150,
        additionalMealExpensesHalf: 32,
        additionalMealExpensesFull: 48,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.VE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.VE.nationality')
    },
    requiresWorkPermit: true,
    code: 'VE',
    sasc: 367,
    ntkz: 'YV',
    payments: [
      {
        overnightStayExpenses: 127,
        additionalMealExpensesHalf: 30,
        additionalMealExpensesFull: 45,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.AE.name')
    },
    get nationality() {
      return i18n.t('frontend:country.AE.nationality')
    },
    requiresWorkPermit: true,
    code: 'AE',
    sasc: 469,
    ntkz: 'UAE',
    payments: [
      {
        overnightStayExpenses: 156,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 65,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.US.name')
    },
    get nationality() {
      return i18n.t('frontend:country.US.nationality')
    },
    requiresWorkPermit: true,
    code: 'US',
    sasc: 368,
    ntkz: 'USA',
    payments: [
      {
        overnightStayExpenses: 182,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'Rest',
      },
      {
        overnightStayExpenses: 182,
        additionalMealExpensesHalf: 52,
        additionalMealExpensesFull: 77,
        name: 'Atlanta',
      },
      {
        overnightStayExpenses: 333,
        additionalMealExpensesHalf: 42,
        additionalMealExpensesFull: 63,
        name: 'Boston',
      },
      {
        overnightStayExpenses: 233,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 65,
        name: 'Chicago',
      },
      {
        overnightStayExpenses: 204,
        additionalMealExpensesHalf: 41,
        additionalMealExpensesFull: 62,
        name: 'Houston',
      },
      {
        overnightStayExpenses: 262,
        additionalMealExpensesHalf: 43,
        additionalMealExpensesFull: 64,
        name: 'Los Angeles',
      },
      {
        overnightStayExpenses: 256,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 65,
        name: 'Miami',
      },
      {
        overnightStayExpenses: 308,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'New York City',
      },
      {
        overnightStayExpenses: 327,
        additionalMealExpensesHalf: 40,
        additionalMealExpensesFull: 59,
        name: 'San Francisco',
      },
      {
        overnightStayExpenses: 203,
        additionalMealExpensesHalf: 44,
        additionalMealExpensesFull: 66,
        name: 'Washington D.C.',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.VN.name')
    },
    get nationality() {
      return i18n.t('frontend:country.VN.nationality')
    },
    requiresWorkPermit: true,
    code: 'VN',
    sasc: 432,
    ntkz: 'VN',
    payments: [
      {
        overnightStayExpenses: 86,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 41,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CF.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CF.nationality')
    },
    requiresWorkPermit: true,
    code: 'CF',
    sasc: 289,
    ntkz: 'RCA',
    payments: [
      {
        overnightStayExpenses: 210,
        additionalMealExpensesHalf: 36,
        additionalMealExpensesFull: 53,
        name: 'Rest',
      },
    ],
  },
  {
    get country() {
      return i18n.t('frontend:country.CY.name')
    },
    get nationality() {
      return i18n.t('frontend:country.CY.nationality')
    },
    requiresWorkPermit: false,
    code: 'CY',
    sasc: 181,
    ntkz: 'CY',
    payments: [
      {
        overnightStayExpenses: 125,
        additionalMealExpensesHalf: 28,
        additionalMealExpensesFull: 42,
        name: 'Rest',
      },
    ],
  },
]

// Unresolved, stateless and unknown nationality (keys 999/998/997). Offered
// for nationality and birth country only, never in the general country list.
// Codes and keys must match functions/src/lib/shared/specialNationalities.ts.
export const specialNationalities = [
  {
    get country() {
      return i18n.t('frontend:country.XU.name')
    },
    get nationality() {
      return i18n.t('frontend:country.XU.nationality')
    },
    requiresWorkPermit: true,
    code: 'XU',
    sasc: 999,
  },
  {
    get country() {
      return i18n.t('frontend:country.XS.name')
    },
    get nationality() {
      return i18n.t('frontend:country.XS.nationality')
    },
    requiresWorkPermit: true,
    code: 'XS',
    sasc: 998,
  },
  {
    get country() {
      return i18n.t('frontend:country.XX.name')
    },
    get nationality() {
      return i18n.t('frontend:country.XX.nationality')
    },
    requiresWorkPermit: true,
    code: 'XX',
    sasc: 997,
  },
]

export const nationalityOptions = [...countries, ...specialNationalities]
